import { Component } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ObjectLookupComponent } from './object-lookup.component';

@Component({
  selector: 'app-hscode-object-lookup',
  templateUrl: './hscode-object-lookup.component.html',
  styleUrls: ['./object-lookup.component.scss']
})
export class HsCodeObjectLookupComponent extends ObjectLookupComponent {
  constructor() {
    super();
  }

  protected loadObjectByIdFromService(id: number) {
    // No HSCode service available yet - switch to search mode
    this.isLoadingObject = false;
    this.selectedObject = null;
    this.searchResults = [];
    this.searchTerm = '';
    this.isSearching = true;
  }

  protected searchObjects(searchText: string): Observable<any[]> {
    // No HSCode search API available yet
    return of([]);
  }

  public getObjectType(): string {
    return 'HSCode';
  }

  public getObjectName(item: any): string {
    return item?.Code || item?.HSCode || item?.Description || '';
  }

  public getObjectId(item: any): number | null {
    return item?.ID ?? item?.HSCodeID ?? null;
  }
}
